/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { GProps } from 'react-native-svg';
import Underway from './Underway';
import TvO from './TvO';
import UmbrellaCircle from './UmbrellaCircle';
import Video from './Video';
import VipCard from './VipCard';
import Service from './Service';
import VolumeO from './VolumeO';
import UserO from './UserO';
import WapNav from './WapNav';
import WapHome from './WapHome';
import VideoO from './VideoO';
import WapHomeO from './WapHomeO';
import WeappNav from './WeappNav';
import UnderwayO from './UnderwayO';
import Warning from './Warning';
import VipCardO from './VipCardO';
import Volume from './Volume';
import UserCircleO from './UserCircleO';
import WarnO from './WarnO';
import WarningO from './WarningO';
import WechatPay from './WechatPay';
import Shrink from './Shrink';
import Star from './Star';
import YouzanShield from './YouzanShield';
import ThumbCircle from './ThumbCircle';
import TodoListO from './TodoListO';
import ThumbCircleO from './ThumbCircleO';
import Wechat from './Wechat';
import Upgrade from './Upgrade';
import ShieldO from './ShieldO';
import Invitation from './Invitation';
import GuideO from './GuideO';
import AddSquare from './AddSquare';
import Add from './Add';
import AddO from './AddO';
import ArrowLeft from './ArrowLeft';
import Aim from './Aim';
import Arrow from './Arrow';
import ArrowUp from './ArrowUp';
import ArrowDown from './ArrowDown';
import Alipay from './Alipay';
import Ascending from './Ascending';
import AfterSale from './AfterSale';
import BagO from './BagO';
import Audio from './Audio';
import BackTop from './BackTop';
import Award from './Award';
import Bag from './Bag';
import AwardO from './AwardO';
import BalanceList from './BalanceList';
import BalanceO from './BalanceO';
import Bell from './Bell';
import BarChartO from './BarChartO';
import BalanceListO from './BalanceListO';
import Bars from './Bars';
import BalancePay from './BalancePay';
import BirthdayCakeO from './BirthdayCakeO';
import BillO from './BillO';
import Bookmark from './Bookmark';
import BookmarkO from './BookmarkO';
import BrowsingHistoryO from './BrowsingHistoryO';
import BrushO from './BrushO';
import Bill from './Bill';
import BullhornO from './BullhornO';
import BulbO from './BulbO';
import CalendarO from './CalendarO';
import Card from './Card';
import Cart from './Cart';
import BrowsingHistory from './BrowsingHistory';
import CartO from './CartO';
import ChartTrendingO from './ChartTrendingO';
import CashBackRecord from './CashBackRecord';
import Certificate from './Certificate';
import CashierO from './CashierO';
import CashOnDeliver from './CashOnDeliver';
import CartCircleO from './CartCircleO';
import Chat from './Chat';
import Clock from './Clock';
import Circle from './Circle';
import CartCircle from './CartCircle';
import AppsO from './AppsO';
import Clear from './Clear';
import Close from './Close';
import Checked from './Checked';
import CommentO from './CommentO';
import CommentCircleO from './CommentCircleO';
import ClosedEye from './ClosedEye';
import ClockO from './ClockO';
import ClusterO from './ClusterO';
import ChatO from './ChatO';
import Cluster from './Cluster';
import Column from './Column';
import Comment from './Comment';
import Contact from './Contact';
import CreditPay from './CreditPay';
import CouponO from './CouponO';
import Completed from './Completed';
import Descending from './Descending';
import CommentCircle from './CommentCircle';
import Cross from './Cross';
import Diamond from './Diamond';
import Delete from './Delete';
import DiamondO from './DiamondO';
import EnvelopO from './EnvelopO';
import DesktopO from './DesktopO';
import EcardPay from './EcardPay';
import Edit from './Edit';
import Coupon from './Coupon';
import DeleteO from './DeleteO';
import Down from './Down';
import Ellipsis from './Ellipsis';
import Enlarge from './Enlarge';
import Expand from './Expand';
import Description from './Description';
import Exchange from './Exchange';
import EyeO from './EyeO';
import ExpandO from './ExpandO';
import Eye from './Eye';
import Fail from './Fail';
import DebitPay from './DebitPay';
import Discount from './Discount';
import FilterO from './FilterO';
import Failure from './Failure';
import Fire from './Fire';
import Font from './Font';
import FlagO from './FlagO';
import FontO from './FontO';
import FireO from './FireO';
import FreePostage from './FreePostage';
import FriendsO from './FriendsO';
import GemO from './GemO';
import Gem from './Gem';
import Friends from './Friends';
import Gift from './Gift';
import GiftO from './GiftO';
import GiftCardO from './GiftCardO';
import GoodJob from './GoodJob';
import FlowerO from './FlowerO';
import GoldCoinO from './GoldCoinO';
import GoldCoin from './GoldCoin';
import GoodJobO from './GoodJobO';
import HomeO from './HomeO';
import GiftCard from './GiftCard';
import Graphic from './Graphic';
import HotO from './HotO';
import Idcard from './Idcard';
import HotSaleO from './HotSaleO';
import Info from './Info';
import HotSale from './HotSale';
import HotelO from './HotelO';
import GoodsCollectO from './GoodsCollectO';
import InfoO from './InfoO';
import LabelO from './LabelO';
import Hot from './Hot';
import Label from './Label';
import LocationO from './LocationO';
import GoodsCollect from './GoodsCollect';
import Location from './Location';
import Lock from './Lock';
import LikeO from './LikeO';
import Live from './Live';
import ManagerO from './ManagerO';
import Like from './Like';
import Manager from './Manager';
import MapMarked from './MapMarked';
import Logistics from './Logistics';
import More from './More';
import Medal from './Medal';
import MoreO from './MoreO';
import MusicO from './MusicO';
import Music from './Music';
import NewspaperO from './NewspaperO';
import Minus from './Minus';
import NewO from './NewO';
import NewArrival from './NewArrival';
import NotesO from './NotesO';
import OrdersO from './OrdersO';
import MedalO from './MedalO';
import New from './New';
import NewArrivalO from './NewArrivalO';
import OtherPay from './OtherPay';
import Pause from './Pause';
import PeerPay from './PeerPay';
import Paid from './Paid';
import Passed from './Passed';
import PauseCircle from './PauseCircle';
import PauseCircleO from './PauseCircleO';
import PhoneO from './PhoneO';
import PendingPayment from './PendingPayment';
import Photograph from './Photograph';
import PhoneCircle from './PhoneCircle';
import PhotoFail from './PhotoFail';
import Phone from './Phone';
import Photo from './Photo';
import Plus from './Plus';
import PhotoO from './PhotoO';
import Play from './Play';
import PlayCircle from './PlayCircle';
import Share from './Share';
import PointGift from './PointGift';
import Points from './Points';
import PointGiftO from './PointGiftO';
import Printer from './Printer';
import Revoke from './Revoke';
import Search from './Search';
import PhoneCircleO from './PhoneCircleO';
import SendGiftO from './SendGiftO';
import Scan from './Scan';
import SendGift from './SendGift';
import Qr from './Qr';
import PlayCircleO from './PlayCircleO';
import StopCircleO from './StopCircleO';
import ServiceO from './ServiceO';
import QrInvalid from './QrInvalid';
import QuestionO from './QuestionO';
import Records from './Records';
import Setting from './Setting';
import SettingO from './SettingO';
import ShopCollectO from './ShopCollectO';
import ShareO from './ShareO';
import Replay from './Replay';
import Question from './Question';
import RefundO from './RefundO';
import ShoppingCart from './ShoppingCart';
import Shop from './Shop';
import ShoppingCartO from './ShoppingCartO';
import ShopCollect from './ShopCollect';
import Sign from './Sign';
import ShopO from './ShopO';
import SmileO from './SmileO';
import SmileCommentO from './SmileCommentO';
import Stop from './Stop';
import Smile from './Smile';
import StopCircle from './StopCircle';
import Success from './Success';
import SmileComment from './SmileComment';
import Tosend from './Tosend';
import StarO from './StarO';
import TodoList from './TodoList';
import Sort from './Sort';
export { default as Underway } from './Underway';
export { default as TvO } from './TvO';
export { default as UmbrellaCircle } from './UmbrellaCircle';
export { default as Video } from './Video';
export { default as VipCard } from './VipCard';
export { default as Service } from './Service';
export { default as VolumeO } from './VolumeO';
export { default as UserO } from './UserO';
export { default as WapNav } from './WapNav';
export { default as WapHome } from './WapHome';
export { default as VideoO } from './VideoO';
export { default as WapHomeO } from './WapHomeO';
export { default as WeappNav } from './WeappNav';
export { default as UnderwayO } from './UnderwayO';
export { default as Warning } from './Warning';
export { default as VipCardO } from './VipCardO';
export { default as Volume } from './Volume';
export { default as UserCircleO } from './UserCircleO';
export { default as WarnO } from './WarnO';
export { default as WarningO } from './WarningO';
export { default as WechatPay } from './WechatPay';
export { default as Shrink } from './Shrink';
export { default as Star } from './Star';
export { default as YouzanShield } from './YouzanShield';
export { default as ThumbCircle } from './ThumbCircle';
export { default as TodoListO } from './TodoListO';
export { default as ThumbCircleO } from './ThumbCircleO';
export { default as Wechat } from './Wechat';
export { default as Upgrade } from './Upgrade';
export { default as ShieldO } from './ShieldO';
export { default as Invitation } from './Invitation';
export { default as GuideO } from './GuideO';
export { default as AddSquare } from './AddSquare';
export { default as Add } from './Add';
export { default as AddO } from './AddO';
export { default as ArrowLeft } from './ArrowLeft';
export { default as Aim } from './Aim';
export { default as Arrow } from './Arrow';
export { default as ArrowUp } from './ArrowUp';
export { default as ArrowDown } from './ArrowDown';
export { default as Alipay } from './Alipay';
export { default as Ascending } from './Ascending';
export { default as AfterSale } from './AfterSale';
export { default as BagO } from './BagO';
export { default as Audio } from './Audio';
export { default as BackTop } from './BackTop';
export { default as Award } from './Award';
export { default as Bag } from './Bag';
export { default as AwardO } from './AwardO';
export { default as BalanceList } from './BalanceList';
export { default as BalanceO } from './BalanceO';
export { default as Bell } from './Bell';
export { default as BarChartO } from './BarChartO';
export { default as BalanceListO } from './BalanceListO';
export { default as Bars } from './Bars';
export { default as BalancePay } from './BalancePay';
export { default as BirthdayCakeO } from './BirthdayCakeO';
export { default as BillO } from './BillO';
export { default as Bookmark } from './Bookmark';
export { default as BookmarkO } from './BookmarkO';
export { default as BrowsingHistoryO } from './BrowsingHistoryO';
export { default as BrushO } from './BrushO';
export { default as Bill } from './Bill';
export { default as BullhornO } from './BullhornO';
export { default as BulbO } from './BulbO';
export { default as CalendarO } from './CalendarO';
export { default as Card } from './Card';
export { default as Cart } from './Cart';
export { default as BrowsingHistory } from './BrowsingHistory';
export { default as CartO } from './CartO';
export { default as ChartTrendingO } from './ChartTrendingO';
export { default as CashBackRecord } from './CashBackRecord';
export { default as Certificate } from './Certificate';
export { default as CashierO } from './CashierO';
export { default as CashOnDeliver } from './CashOnDeliver';
export { default as CartCircleO } from './CartCircleO';
export { default as Chat } from './Chat';
export { default as Clock } from './Clock';
export { default as Circle } from './Circle';
export { default as CartCircle } from './CartCircle';
export { default as AppsO } from './AppsO';
export { default as Clear } from './Clear';
export { default as Close } from './Close';
export { default as Checked } from './Checked';
export { default as CommentO } from './CommentO';
export { default as CommentCircleO } from './CommentCircleO';
export { default as ClosedEye } from './ClosedEye';
export { default as ClockO } from './ClockO';
export { default as ClusterO } from './ClusterO';
export { default as ChatO } from './ChatO';
export { default as Cluster } from './Cluster';
export { default as Column } from './Column';
export { default as Comment } from './Comment';
export { default as Contact } from './Contact';
export { default as CreditPay } from './CreditPay';
export { default as CouponO } from './CouponO';
export { default as Completed } from './Completed';
export { default as Descending } from './Descending';
export { default as CommentCircle } from './CommentCircle';
export { default as Cross } from './Cross';
export { default as Diamond } from './Diamond';
export { default as Delete } from './Delete';
export { default as DiamondO } from './DiamondO';
export { default as EnvelopO } from './EnvelopO';
export { default as DesktopO } from './DesktopO';
export { default as EcardPay } from './EcardPay';
export { default as Edit } from './Edit';
export { default as Coupon } from './Coupon';
export { default as DeleteO } from './DeleteO';
export { default as Down } from './Down';
export { default as Ellipsis } from './Ellipsis';
export { default as Enlarge } from './Enlarge';
export { default as Expand } from './Expand';
export { default as Description } from './Description';
export { default as Exchange } from './Exchange';
export { default as EyeO } from './EyeO';
export { default as ExpandO } from './ExpandO';
export { default as Eye } from './Eye';
export { default as Fail } from './Fail';
export { default as DebitPay } from './DebitPay';
export { default as Discount } from './Discount';
export { default as FilterO } from './FilterO';
export { default as Failure } from './Failure';
export { default as Fire } from './Fire';
export { default as Font } from './Font';
export { default as FlagO } from './FlagO';
export { default as FontO } from './FontO';
export { default as FireO } from './FireO';
export { default as FreePostage } from './FreePostage';
export { default as FriendsO } from './FriendsO';
export { default as GemO } from './GemO';
export { default as Gem } from './Gem';
export { default as Friends } from './Friends';
export { default as Gift } from './Gift';
export { default as GiftO } from './GiftO';
export { default as GiftCardO } from './GiftCardO';
export { default as GoodJob } from './GoodJob';
export { default as FlowerO } from './FlowerO';
export { default as GoldCoinO } from './GoldCoinO';
export { default as GoldCoin } from './GoldCoin';
export { default as GoodJobO } from './GoodJobO';
export { default as HomeO } from './HomeO';
export { default as GiftCard } from './GiftCard';
export { default as Graphic } from './Graphic';
export { default as HotO } from './HotO';
export { default as Idcard } from './Idcard';
export { default as HotSaleO } from './HotSaleO';
export { default as Info } from './Info';
export { default as HotSale } from './HotSale';
export { default as HotelO } from './HotelO';
export { default as GoodsCollectO } from './GoodsCollectO';
export { default as InfoO } from './InfoO';
export { default as LabelO } from './LabelO';
export { default as Hot } from './Hot';
export { default as Label } from './Label';
export { default as LocationO } from './LocationO';
export { default as GoodsCollect } from './GoodsCollect';
export { default as Location } from './Location';
export { default as Lock } from './Lock';
export { default as LikeO } from './LikeO';
export { default as Live } from './Live';
export { default as ManagerO } from './ManagerO';
export { default as Like } from './Like';
export { default as Manager } from './Manager';
export { default as MapMarked } from './MapMarked';
export { default as Logistics } from './Logistics';
export { default as More } from './More';
export { default as Medal } from './Medal';
export { default as MoreO } from './MoreO';
export { default as MusicO } from './MusicO';
export { default as Music } from './Music';
export { default as NewspaperO } from './NewspaperO';
export { default as Minus } from './Minus';
export { default as NewO } from './NewO';
export { default as NewArrival } from './NewArrival';
export { default as NotesO } from './NotesO';
export { default as OrdersO } from './OrdersO';
export { default as MedalO } from './MedalO';
export { default as New } from './New';
export { default as NewArrivalO } from './NewArrivalO';
export { default as OtherPay } from './OtherPay';
export { default as Pause } from './Pause';
export { default as PeerPay } from './PeerPay';
export { default as Paid } from './Paid';
export { default as Passed } from './Passed';
export { default as PauseCircle } from './PauseCircle';
export { default as PauseCircleO } from './PauseCircleO';
export { default as PhoneO } from './PhoneO';
export { default as PendingPayment } from './PendingPayment';
export { default as Photograph } from './Photograph';
export { default as PhoneCircle } from './PhoneCircle';
export { default as PhotoFail } from './PhotoFail';
export { default as Phone } from './Phone';
export { default as Photo } from './Photo';
export { default as Plus } from './Plus';
export { default as PhotoO } from './PhotoO';
export { default as Play } from './Play';
export { default as PlayCircle } from './PlayCircle';
export { default as Share } from './Share';
export { default as PointGift } from './PointGift';
export { default as Points } from './Points';
export { default as PointGiftO } from './PointGiftO';
export { default as Printer } from './Printer';
export { default as Revoke } from './Revoke';
export { default as Search } from './Search';
export { default as PhoneCircleO } from './PhoneCircleO';
export { default as SendGiftO } from './SendGiftO';
export { default as Scan } from './Scan';
export { default as SendGift } from './SendGift';
export { default as Qr } from './Qr';
export { default as PlayCircleO } from './PlayCircleO';
export { default as StopCircleO } from './StopCircleO';
export { default as ServiceO } from './ServiceO';
export { default as QrInvalid } from './QrInvalid';
export { default as QuestionO } from './QuestionO';
export { default as Records } from './Records';
export { default as Setting } from './Setting';
export { default as SettingO } from './SettingO';
export { default as ShopCollectO } from './ShopCollectO';
export { default as ShareO } from './ShareO';
export { default as Replay } from './Replay';
export { default as Question } from './Question';
export { default as RefundO } from './RefundO';
export { default as ShoppingCart } from './ShoppingCart';
export { default as Shop } from './Shop';
export { default as ShoppingCartO } from './ShoppingCartO';
export { default as ShopCollect } from './ShopCollect';
export { default as Sign } from './Sign';
export { default as ShopO } from './ShopO';
export { default as SmileO } from './SmileO';
export { default as SmileCommentO } from './SmileCommentO';
export { default as Stop } from './Stop';
export { default as Smile } from './Smile';
export { default as StopCircle } from './StopCircle';
export { default as Success } from './Success';
export { default as SmileComment } from './SmileComment';
export { default as Tosend } from './Tosend';
export { default as StarO } from './StarO';
export { default as TodoList } from './TodoList';
export { default as Sort } from './Sort';

export type IconNames = 'underway' | 'tv-o' | 'umbrella-circle' | 'video' | 'vip-card' | 'service' | 'volume-o' | 'user-o' | 'wap-nav' | 'wap-home' | 'video-o' | 'wap-home-o' | 'weapp-nav' | 'underway-o' | 'warning' | 'vip-card-o' | 'volume' | 'user-circle-o' | 'warn-o' | 'warning-o' | 'wechat-pay' | 'shrink' | 'star' | 'youzan-shield' | 'thumb-circle' | 'todo-list-o' | 'thumb-circle-o' | 'wechat' | 'upgrade' | 'shield-o' | 'invitation' | 'guide-o' | 'add-square' | 'add' | 'add-o' | 'arrow-left' | 'aim' | 'arrow' | 'arrow-up' | 'arrow-down' | 'alipay' | 'ascending' | 'after-sale' | 'bag-o' | 'audio' | 'back-top' | 'award' | 'bag' | 'award-o' | 'balance-list' | 'balance-o' | 'bell' | 'bar-chart-o' | 'balance-list-o' | 'bars' | 'balance-pay' | 'birthday-cake-o' | 'bill-o' | 'bookmark' | 'bookmark-o' | 'browsing-history-o' | 'brush-o' | 'bill' | 'bullhorn-o' | 'bulb-o' | 'calendar-o' | 'card' | 'cart' | 'browsing-history' | 'cart-o' | 'chart-trending-o' | 'cash-back-record' | 'certificate' | 'cashier-o' | 'cash-on-deliver' | 'cart-circle-o' | 'chat' | 'clock' | 'circle' | 'cart-circle' | 'apps-o' | 'clear' | 'close' | 'checked' | 'comment-o' | 'comment-circle-o' | 'closed-eye' | 'clock-o' | 'cluster-o' | 'chat-o' | 'cluster' | 'column' | 'comment' | 'contact' | 'credit-pay' | 'coupon-o' | 'completed' | 'descending' | 'comment-circle' | 'cross' | 'diamond' | 'delete' | 'diamond-o' | 'envelop-o' | 'desktop-o' | 'ecard-pay' | 'edit' | 'coupon' | 'delete-o' | 'down' | 'ellipsis' | 'enlarge' | 'expand' | 'description' | 'exchange' | 'eye-o' | 'expand-o' | 'eye' | 'fail' | 'debit-pay' | 'discount' | 'filter-o' | 'failure' | 'fire' | 'font' | 'flag-o' | 'font-o' | 'fire-o' | 'free-postage' | 'friends-o' | 'gem-o' | 'gem' | 'friends' | 'gift' | 'gift-o' | 'gift-card-o' | 'good-job' | 'flower-o' | 'gold-coin-o' | 'gold-coin' | 'good-job-o' | 'home-o' | 'gift-card' | 'graphic' | 'hot-o' | 'idcard' | 'hot-sale-o' | 'info' | 'hot-sale' | 'hotel-o' | 'goods-collect-o' | 'info-o' | 'label-o' | 'hot' | 'label' | 'location-o' | 'goods-collect' | 'location' | 'lock' | 'like-o' | 'live' | 'manager-o' | 'like' | 'manager' | 'map-marked' | 'logistics' | 'more' | 'medal' | 'more-o' | 'music-o' | 'music' | 'newspaper-o' | 'minus' | 'new-o' | 'new-arrival' | 'notes-o' | 'orders-o' | 'medal-o' | 'new' | 'new-arrival-o' | 'other-pay' | 'pause' | 'peer-pay' | 'paid' | 'passed' | 'pause-circle' | 'pause-circle-o' | 'phone-o' | 'pending-payment' | 'photograph' | 'phone-circle' | 'photo-fail' | 'phone' | 'photo' | 'plus' | 'photo-o' | 'play' | 'play-circle' | 'share' | 'point-gift' | 'points' | 'point-gift-o' | 'printer' | 'revoke' | 'search' | 'phone-circle-o' | 'send-gift-o' | 'scan' | 'send-gift' | 'qr' | 'play-circle-o' | 'stop-circle-o' | 'service-o' | 'qr-invalid' | 'question-o' | 'records' | 'setting' | 'setting-o' | 'shop-collect-o' | 'share-o' | 'replay' | 'question' | 'refund-o' | 'shopping-cart' | 'shop' | 'shopping-cart-o' | 'shop-collect' | 'sign' | 'shop-o' | 'smile-o' | 'smile-comment-o' | 'stop' | 'smile' | 'stop-circle' | 'success' | 'smile-comment' | 'tosend' | 'star-o' | 'todo-list' | 'sort';

interface Props extends GProps, ViewProps {
  name: IconNames;
  size?: number;
  color?: string | string[];
}

let IconFont: FunctionComponent<Props> = ({ name, ...rest }) => {
  switch (name) {
    case 'underway':
      return <Underway key="1" {...rest} />;
    case 'tv-o':
      return <TvO key="2" {...rest} />;
    case 'umbrella-circle':
      return <UmbrellaCircle key="3" {...rest} />;
    case 'video':
      return <Video key="4" {...rest} />;
    case 'vip-card':
      return <VipCard key="5" {...rest} />;
    case 'service':
      return <Service key="6" {...rest} />;
    case 'volume-o':
      return <VolumeO key="7" {...rest} />;
    case 'user-o':
      return <UserO key="8" {...rest} />;
    case 'wap-nav':
      return <WapNav key="9" {...rest} />;
    case 'wap-home':
      return <WapHome key="10" {...rest} />;
    case 'video-o':
      return <VideoO key="11" {...rest} />;
    case 'wap-home-o':
      return <WapHomeO key="12" {...rest} />;
    case 'weapp-nav':
      return <WeappNav key="13" {...rest} />;
    case 'underway-o':
      return <UnderwayO key="14" {...rest} />;
    case 'warning':
      return <Warning key="15" {...rest} />;
    case 'vip-card-o':
      return <VipCardO key="16" {...rest} />;
    case 'volume':
      return <Volume key="17" {...rest} />;
    case 'user-circle-o':
      return <UserCircleO key="18" {...rest} />;
    case 'warn-o':
      return <WarnO key="19" {...rest} />;
    case 'warning-o':
      return <WarningO key="20" {...rest} />;
    case 'wechat-pay':
      return <WechatPay key="21" {...rest} />;
    case 'shrink':
      return <Shrink key="22" {...rest} />;
    case 'star':
      return <Star key="23" {...rest} />;
    case 'youzan-shield':
      return <YouzanShield key="24" {...rest} />;
    case 'thumb-circle':
      return <ThumbCircle key="25" {...rest} />;
    case 'todo-list-o':
      return <TodoListO key="26" {...rest} />;
    case 'thumb-circle-o':
      return <ThumbCircleO key="27" {...rest} />;
    case 'wechat':
      return <Wechat key="28" {...rest} />;
    case 'upgrade':
      return <Upgrade key="29" {...rest} />;
    case 'shield-o':
      return <ShieldO key="30" {...rest} />;
    case 'invitation':
      return <Invitation key="31" {...rest} />;
    case 'guide-o':
      return <GuideO key="32" {...rest} />;
    case 'add-square':
      return <AddSquare key="33" {...rest} />;
    case 'add':
      return <Add key="34" {...rest} />;
    case 'add-o':
      return <AddO key="35" {...rest} />;
    case 'arrow-left':
      return <ArrowLeft key="36" {...rest} />;
    case 'aim':
      return <Aim key="37" {...rest} />;
    case 'arrow':
      return <Arrow key="38" {...rest} />;
    case 'arrow-up':
      return <ArrowUp key="39" {...rest} />;
    case 'arrow-down':
      return <ArrowDown key="40" {...rest} />;
    case 'alipay':
      return <Alipay key="41" {...rest} />;
    case 'ascending':
      return <Ascending key="42" {...rest} />;
    case 'after-sale':
      return <AfterSale key="43" {...rest} />;
    case 'bag-o':
      return <BagO key="44" {...rest} />;
    case 'audio':
      return <Audio key="45" {...rest} />;
    case 'back-top':
      return <BackTop key="46" {...rest} />;
    case 'award':
      return <Award key="47" {...rest} />;
    case 'bag':
      return <Bag key="48" {...rest} />;
    case 'award-o':
      return <AwardO key="49" {...rest} />;
    case 'balance-list':
      return <BalanceList key="50" {...rest} />;
    case 'balance-o':
      return <BalanceO key="51" {...rest} />;
    case 'bell':
      return <Bell key="52" {...rest} />;
    case 'bar-chart-o':
      return <BarChartO key="53" {...rest} />;
    case 'balance-list-o':
      return <BalanceListO key="54" {...rest} />;
    case 'bars':
      return <Bars key="55" {...rest} />;
    case 'balance-pay':
      return <BalancePay key="56" {...rest} />;
    case 'birthday-cake-o':
      return <BirthdayCakeO key="57" {...rest} />;
    case 'bill-o':
      return <BillO key="58" {...rest} />;
    case 'bookmark':
      return <Bookmark key="59" {...rest} />;
    case 'bookmark-o':
      return <BookmarkO key="60" {...rest} />;
    case 'browsing-history-o':
      return <BrowsingHistoryO key="61" {...rest} />;
    case 'brush-o':
      return <BrushO key="62" {...rest} />;
    case 'bill':
      return <Bill key="63" {...rest} />;
    case 'bullhorn-o':
      return <BullhornO key="64" {...rest} />;
    case 'bulb-o':
      return <BulbO key="65" {...rest} />;
    case 'calendar-o':
      return <CalendarO key="66" {...rest} />;
    case 'card':
      return <Card key="67" {...rest} />;
    case 'cart':
      return <Cart key="68" {...rest} />;
    case 'browsing-history':
      return <BrowsingHistory key="69" {...rest} />;
    case 'cart-o':
      return <CartO key="70" {...rest} />;
    case 'chart-trending-o':
      return <ChartTrendingO key="71" {...rest} />;
    case 'cash-back-record':
      return <CashBackRecord key="72" {...rest} />;
    case 'certificate':
      return <Certificate key="73" {...rest} />;
    case 'cashier-o':
      return <CashierO key="74" {...rest} />;
    case 'cash-on-deliver':
      return <CashOnDeliver key="75" {...rest} />;
    case 'cart-circle-o':
      return <CartCircleO key="76" {...rest} />;
    case 'chat':
      return <Chat key="77" {...rest} />;
    case 'clock':
      return <Clock key="78" {...rest} />;
    case 'circle':
      return <Circle key="79" {...rest} />;
    case 'cart-circle':
      return <CartCircle key="80" {...rest} />;
    case 'apps-o':
      return <AppsO key="81" {...rest} />;
    case 'clear':
      return <Clear key="82" {...rest} />;
    case 'close':
      return <Close key="83" {...rest} />;
    case 'checked':
      return <Checked key="84" {...rest} />;
    case 'comment-o':
      return <CommentO key="85" {...rest} />;
    case 'comment-circle-o':
      return <CommentCircleO key="86" {...rest} />;
    case 'closed-eye':
      return <ClosedEye key="87" {...rest} />;
    case 'clock-o':
      return <ClockO key="88" {...rest} />;
    case 'cluster-o':
      return <ClusterO key="89" {...rest} />;
    case 'chat-o':
      return <ChatO key="90" {...rest} />;
    case 'cluster':
      return <Cluster key="91" {...rest} />;
    case 'column':
      return <Column key="92" {...rest} />;
    case 'comment':
      return <Comment key="93" {...rest} />;
    case 'contact':
      return <Contact key="94" {...rest} />;
    case 'credit-pay':
      return <CreditPay key="95" {...rest} />;
    case 'coupon-o':
      return <CouponO key="96" {...rest} />;
    case 'completed':
      return <Completed key="97" {...rest} />;
    case 'descending':
      return <Descending key="98" {...rest} />;
    case 'comment-circle':
      return <CommentCircle key="99" {...rest} />;
    case 'cross':
      return <Cross key="100" {...rest} />;
    case 'diamond':
      return <Diamond key="101" {...rest} />;
    case 'delete':
      return <Delete key="102" {...rest} />;
    case 'diamond-o':
      return <DiamondO key="103" {...rest} />;
    case 'envelop-o':
      return <EnvelopO key="104" {...rest} />;
    case 'desktop-o':
      return <DesktopO key="105" {...rest} />;
    case 'ecard-pay':
      return <EcardPay key="106" {...rest} />;
    case 'edit':
      return <Edit key="107" {...rest} />;
    case 'coupon':
      return <Coupon key="108" {...rest} />;
    case 'delete-o':
      return <DeleteO key="109" {...rest} />;
    case 'down':
      return <Down key="110" {...rest} />;
    case 'ellipsis':
      return <Ellipsis key="111" {...rest} />;
    case 'enlarge':
      return <Enlarge key="112" {...rest} />;
    case 'expand':
      return <Expand key="113" {...rest} />;
    case 'description':
      return <Description key="114" {...rest} />;
    case 'exchange':
      return <Exchange key="115" {...rest} />;
    case 'eye-o':
      return <EyeO key="116" {...rest} />;
    case 'expand-o':
      return <ExpandO key="117" {...rest} />;
    case 'eye':
      return <Eye key="118" {...rest} />;
    case 'fail':
      return <Fail key="119" {...rest} />;
    case 'debit-pay':
      return <DebitPay key="120" {...rest} />;
    case 'discount':
      return <Discount key="121" {...rest} />;
    case 'filter-o':
      return <FilterO key="122" {...rest} />;
    case 'failure':
      return <Failure key="123" {...rest} />;
    case 'fire':
      return <Fire key="124" {...rest} />;
    case 'font':
      return <Font key="125" {...rest} />;
    case 'flag-o':
      return <FlagO key="126" {...rest} />;
    case 'font-o':
      return <FontO key="127" {...rest} />;
    case 'fire-o':
      return <FireO key="128" {...rest} />;
    case 'free-postage':
      return <FreePostage key="129" {...rest} />;
    case 'friends-o':
      return <FriendsO key="130" {...rest} />;
    case 'gem-o':
      return <GemO key="131" {...rest} />;
    case 'gem':
      return <Gem key="132" {...rest} />;
    case 'friends':
      return <Friends key="133" {...rest} />;
    case 'gift':
      return <Gift key="134" {...rest} />;
    case 'gift-o':
      return <GiftO key="135" {...rest} />;
    case 'gift-card-o':
      return <GiftCardO key="136" {...rest} />;
    case 'good-job':
      return <GoodJob key="137" {...rest} />;
    case 'flower-o':
      return <FlowerO key="138" {...rest} />;
    case 'gold-coin-o':
      return <GoldCoinO key="139" {...rest} />;
    case 'gold-coin':
      return <GoldCoin key="140" {...rest} />;
    case 'good-job-o':
      return <GoodJobO key="141" {...rest} />;
    case 'home-o':
      return <HomeO key="142" {...rest} />;
    case 'gift-card':
      return <GiftCard key="143" {...rest} />;
    case 'graphic':
      return <Graphic key="144" {...rest} />;
    case 'hot-o':
      return <HotO key="145" {...rest} />;
    case 'idcard':
      return <Idcard key="146" {...rest} />;
    case 'hot-sale-o':
      return <HotSaleO key="147" {...rest} />;
    case 'info':
      return <Info key="148" {...rest} />;
    case 'hot-sale':
      return <HotSale key="149" {...rest} />;
    case 'hotel-o':
      return <HotelO key="150" {...rest} />;
    case 'goods-collect-o':
      return <GoodsCollectO key="151" {...rest} />;
    case 'info-o':
      return <InfoO key="152" {...rest} />;
    case 'label-o':
      return <LabelO key="153" {...rest} />;
    case 'hot':
      return <Hot key="154" {...rest} />;
    case 'label':
      return <Label key="155" {...rest} />;
    case 'location-o':
      return <LocationO key="156" {...rest} />;
    case 'goods-collect':
      return <GoodsCollect key="157" {...rest} />;
    case 'location':
      return <Location key="158" {...rest} />;
    case 'lock':
      return <Lock key="159" {...rest} />;
    case 'like-o':
      return <LikeO key="160" {...rest} />;
    case 'live':
      return <Live key="161" {...rest} />;
    case 'manager-o':
      return <ManagerO key="162" {...rest} />;
    case 'like':
      return <Like key="163" {...rest} />;
    case 'manager':
      return <Manager key="164" {...rest} />;
    case 'map-marked':
      return <MapMarked key="165" {...rest} />;
    case 'logistics':
      return <Logistics key="166" {...rest} />;
    case 'more':
      return <More key="167" {...rest} />;
    case 'medal':
      return <Medal key="168" {...rest} />;
    case 'more-o':
      return <MoreO key="169" {...rest} />;
    case 'music-o':
      return <MusicO key="170" {...rest} />;
    case 'music':
      return <Music key="171" {...rest} />;
    case 'newspaper-o':
      return <NewspaperO key="172" {...rest} />;
    case 'minus':
      return <Minus key="173" {...rest} />;
    case 'new-o':
      return <NewO key="174" {...rest} />;
    case 'new-arrival':
      return <NewArrival key="175" {...rest} />;
    case 'notes-o':
      return <NotesO key="176" {...rest} />;
    case 'orders-o':
      return <OrdersO key="177" {...rest} />;
    case 'medal-o':
      return <MedalO key="178" {...rest} />;
    case 'new':
      return <New key="179" {...rest} />;
    case 'new-arrival-o':
      return <NewArrivalO key="180" {...rest} />;
    case 'other-pay':
      return <OtherPay key="181" {...rest} />;
    case 'pause':
      return <Pause key="182" {...rest} />;
    case 'peer-pay':
      return <PeerPay key="183" {...rest} />;
    case 'paid':
      return <Paid key="184" {...rest} />;
    case 'passed':
      return <Passed key="185" {...rest} />;
    case 'pause-circle':
      return <PauseCircle key="186" {...rest} />;
    case 'pause-circle-o':
      return <PauseCircleO key="187" {...rest} />;
    case 'phone-o':
      return <PhoneO key="188" {...rest} />;
    case 'pending-payment':
      return <PendingPayment key="189" {...rest} />;
    case 'photograph':
      return <Photograph key="190" {...rest} />;
    case 'phone-circle':
      return <PhoneCircle key="191" {...rest} />;
    case 'photo-fail':
      return <PhotoFail key="192" {...rest} />;
    case 'phone':
      return <Phone key="193" {...rest} />;
    case 'photo':
      return <Photo key="194" {...rest} />;
    case 'plus':
      return <Plus key="195" {...rest} />;
    case 'photo-o':
      return <PhotoO key="196" {...rest} />;
    case 'play':
      return <Play key="197" {...rest} />;
    case 'play-circle':
      return <PlayCircle key="198" {...rest} />;
    case 'share':
      return <Share key="199" {...rest} />;
    case 'point-gift':
      return <PointGift key="200" {...rest} />;
    case 'points':
      return <Points key="201" {...rest} />;
    case 'point-gift-o':
      return <PointGiftO key="202" {...rest} />;
    case 'printer':
      return <Printer key="203" {...rest} />;
    case 'revoke':
      return <Revoke key="204" {...rest} />;
    case 'search':
      return <Search key="205" {...rest} />;
    case 'phone-circle-o':
      return <PhoneCircleO key="206" {...rest} />;
    case 'send-gift-o':
      return <SendGiftO key="207" {...rest} />;
    case 'scan':
      return <Scan key="208" {...rest} />;
    case 'send-gift':
      return <SendGift key="209" {...rest} />;
    case 'qr':
      return <Qr key="210" {...rest} />;
    case 'play-circle-o':
      return <PlayCircleO key="211" {...rest} />;
    case 'stop-circle-o':
      return <StopCircleO key="212" {...rest} />;
    case 'service-o':
      return <ServiceO key="213" {...rest} />;
    case 'qr-invalid':
      return <QrInvalid key="214" {...rest} />;
    case 'question-o':
      return <QuestionO key="215" {...rest} />;
    case 'records':
      return <Records key="216" {...rest} />;
    case 'setting':
      return <Setting key="217" {...rest} />;
    case 'setting-o':
      return <SettingO key="218" {...rest} />;
    case 'shop-collect-o':
      return <ShopCollectO key="219" {...rest} />;
    case 'share-o':
      return <ShareO key="220" {...rest} />;
    case 'replay':
      return <Replay key="221" {...rest} />;
    case 'question':
      return <Question key="222" {...rest} />;
    case 'refund-o':
      return <RefundO key="223" {...rest} />;
    case 'shopping-cart':
      return <ShoppingCart key="224" {...rest} />;
    case 'shop':
      return <Shop key="225" {...rest} />;
    case 'shopping-cart-o':
      return <ShoppingCartO key="226" {...rest} />;
    case 'shop-collect':
      return <ShopCollect key="227" {...rest} />;
    case 'sign':
      return <Sign key="228" {...rest} />;
    case 'shop-o':
      return <ShopO key="229" {...rest} />;
    case 'smile-o':
      return <SmileO key="230" {...rest} />;
    case 'smile-comment-o':
      return <SmileCommentO key="231" {...rest} />;
    case 'stop':
      return <Stop key="232" {...rest} />;
    case 'smile':
      return <Smile key="233" {...rest} />;
    case 'stop-circle':
      return <StopCircle key="234" {...rest} />;
    case 'success':
      return <Success key="235" {...rest} />;
    case 'smile-comment':
      return <SmileComment key="236" {...rest} />;
    case 'tosend':
      return <Tosend key="237" {...rest} />;
    case 'star-o':
      return <StarO key="238" {...rest} />;
    case 'todo-list':
      return <TodoList key="239" {...rest} />;
    case 'sort':
      return <Sort key="240" {...rest} />;
  }

  return null;
};

IconFont = React.memo ? React.memo(IconFont) : IconFont;

export default IconFont;
